export const locale = {
    lang: 'ds',
    data: {
      'BUTTONS': {
        'Upload': 'Upload',
        'Cancel': 'Tilbage',
        "Update":"Opdatere",
        "Reset":"Nulstil / annullere",
        "SampleFileDownload":"Prøve fil download",
        'Back': 'Tilbage',
      },
      'Header':{
        'Kundenr': 'Kundenr',
        'FirmaNavn': 'FirmaNavn',
        'KontaktPerson': 'KontaktPerson',
        'Address': 'Adresse',
        'Postnr': 'Postnr',
        'By': 'By',
        'Telefon': 'Telefon',
        'EmailFaktura': 'EmailFaktura',
        'Email': 'Email',
      },
      'FIELDS': {
        'SelectSupplier': 'Vælg Leverandør',
        'UploadPriceList': 'Upload prisliste',
        'ChooseFile': 'Vælg fil',
      },
      'LABELS': {
        'TITLE': 'Upload af kundeliste (.xls,.xlsx)',
        'NoFileSelected': 'Ingen fil valgt',
        'FileSelected': 'Fil valgt',
      },
      'MESSAGES': {
        'Created': 'Oprettet succesfuldt.',
        'Updated': 'Opdateret succesfuldt.',
        'Failed': 'mislykkedes',
        'Deleted': 'Slettet med succes',
        'Notes':'**Bemærk - Inaktive eller slettede materialer er fremhævet i rød farve'
      },
    }
  }; 
  